import { render, staticRenderFns } from "./activityProductList.vue?vue&type=template&id=88d44048"
import script from "./activityProductList.vue?vue&type=script&lang=js"
export * from "./activityProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports